/**
 * This is a version of Array.prototype.includes that narrows
 * the type of `value` - if it is in the list, then its type will
 * match that of an element in the list.
 */
export const isInList = <T extends string>(value: string, list: readonly T[]): value is T => {
  return list.includes(value as T);
};
